"use client";

import { useEffect, useState } from "react";

import { BuilderContent } from "@builder.io/sdk-react";
import { useSearchParams } from "next/navigation";

import { useConfig } from "@jti/ui/providers/useConfig";

import { Content } from "@/libs/builder/Content";
import { sha256Hash } from "@/utils/sha256Hash";

export const SoftAgeVerificationContent = ({
  content,
}: {
  content: BuilderContent | null;
}) => {
  const config = useConfig();
  const searchParams = useSearchParams();
  const savBypassToken = searchParams.get("savBypassToken");
  const [isBypassed, setIsBypassed] = useState(true);

  useEffect(() => {
    const hashToken = async () => {
      const hashedToken = await sha256Hash(savBypassToken ?? "");
      setIsBypassed(hashedToken === config.SAV_BYPASS_TOKEN);
    };

    hashToken();
  }, [savBypassToken, config.SAV_BYPASS_TOKEN]);

  return isBypassed ? null : (
    <Content model={"soft-age-verification"} content={content} />
  );
};
